import { CheckCircleIcon, QuestionMarkCircleIcon, XCircleIcon, } from '@heroicons/react/solid';
import { pulse, styled, TextTooltip } from '@showroomjs/ui';
import * as React from 'react';
import { useA11yResult } from '../lib/use-a11y-result';
import { Span } from './base';
export const A11ySummary = styled(function A11ySummary(props) {
    const { result, status } = useA11yResult();
    return (React.createElement(TextTooltip, { label: result
            ? `${result.violations.length} violations, ${result.passes.length} passes, ${result.incomplete.length} incompletes`
            : 'Loading...' },
        React.createElement(Root, Object.assign({}, props, (result
            ? {
                'data-a11y-result': result.violations.length === 0 ? 'success' : 'failure',
            }
            : {})),
            React.createElement(Span, { css: {
                    paddingRight: '$1',
                } },
                React.createElement(Span, { css: {
                        srOnly: true,
                        '@sm': {
                            srOnly: false,
                        },
                    } }, "Accessibility"),
                React.createElement(Span, { css: {
                        '@sm': {
                            display: 'none',
                        },
                    } }, "\u267F\uFE0F")),
            React.createElement(SummaryText, { loading: status === 'loading' },
                React.createElement(SummaryTextItem, null,
                    result ? result.violations.length : '?',
                    ' ',
                    React.createElement(DangerIcon, { "aria-label": "violations", width: 16, height: 16 })),
                React.createElement(SummaryTextItem, null,
                    result ? result.passes.length : '?',
                    ' ',
                    React.createElement(SuccessIcon, { "aria-label": "passes", width: 16, height: 16 })),
                React.createElement(SummaryTextItem, null,
                    result ? result.incomplete.length : '?',
                    ' ',
                    React.createElement(UnknownIcon, { "aria-label": "incompletes", width: 16, height: 16 }))))));
});
const Root = styled('button', {
    all: 'unset',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    color: '$gray-500',
    fontSize: '$sm',
    lineHeight: '$sm',
    border: 0,
});
const SummaryText = styled('span', {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '$1',
    variants: {
        loading: {
            true: {
                animation: `${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
            },
        },
    },
});
const SummaryTextItem = styled('span', {
    display: 'inline-flex',
    alignItems: 'center',
});
const SuccessIcon = styled(CheckCircleIcon, {
    color: '$green-500',
    width: 16,
    height: 16,
});
const DangerIcon = styled(XCircleIcon, {
    color: '$red-500',
    width: 16,
    height: 16,
});
const UnknownIcon = styled(QuestionMarkCircleIcon, {
    color: '$yellow-500',
    width: 16,
    height: 16,
});
//# sourceMappingURL=a11y-summary.js.map